import { apiCall } from '../../providers';
import { TableRow } from './types';

const UNITS_CONFIG_TYPES = ['setStatus', 'setWeeklyReport', 'setResponsible', 'setRemoteControlHealth'] as const;
const UNITS_CONFIG_BLOCK_SIZE = 60;

export type UnitsConfigType = typeof UNITS_CONFIG_TYPES[number];

export function getUnitsConfigType(option: string): UnitsConfigType | undefined {
  return UNITS_CONFIG_TYPES.find((type) => type === option);
}

// Envia a configuração em lote de unidades em blocos, para não estourar o tamanho da requisição.
export async function applyUnitsMultipleConfig(type: UnitsConfigType, rows: TableRow[], selected: unknown): Promise<void> {
  const blocks = [] as TableRow[][];
  for (let i = 0; i < rows.length; i += UNITS_CONFIG_BLOCK_SIZE) {
    blocks.push(rows.slice(i, i + UNITS_CONFIG_BLOCK_SIZE));
  }
  await Promise.all(
    blocks.map((block) => apiCall('/clients/multiple-configs-units', {
      UNITS_IDS: block.map((item) => ({ UNIT_ID: item.UNIT_ID, SUPERVISOR_ID: item.SUPERVISOR_ID })),
      TYPE: type,
      SELECTED: (!selected ? 'clear' : selected) as string | string[],
    })),
  );
}
